import './landing.css';
import { LandingCapabilities } from './LandingCapabilities';
import { LandingCta } from './LandingCta';
import { LandingFlow } from './LandingFlow';
import { LandingFooter } from './LandingFooter';
import { LandingHeader } from './LandingHeader';
import { LandingHero } from './LandingHero';

/** Public marketing page for Waterfall, served at `/` ahead of the authenticated app. */
export function LandingPage() {
  return (
    <div className="wf-landing">
      <LandingHeader />
      <main>
        <LandingHero />
        <LandingCapabilities />
        <LandingFlow />
        <LandingCta />
      </main>
      <LandingFooter />
    </div>
  );
}
